import React, { useRef } from 'react'
import LandingHeader from './LandingHeader'

import section2_girl from '../assets/Landing_page/section2_girl.png';
import logo2 from '../assets/Landing_page/logo2.png';
import NewspaperCUTTING from '../assets/Landing_page/NewspaperCUTTING.png';
import card1 from '../assets/Landing_page/card1.png';
import card2 from '../assets/Landing_page/card2.png';
import card3 from '../assets/Landing_page/card3.png';
import card4 from '../assets/Landing_page/card4.png';
import schools from '../assets/Landing_page/schools.png';
import college from '../assets/Landing_page/college.png';
import school_icon from '../assets/Landing_page/school_icon.png';
import college_icon from '../assets/Landing_page/college_icon.png';


import boy_thinking from '../assets/Landing_page/boy_thinking.png';
import laptop_1 from '../assets/Landing_page/laptop_1.png';

// benefits of lexilearn start 
import benefits_1 from '../assets/Landing_page/benefits_of_lexi/benefits_1.png';
import benefits_2 from '../assets/Landing_page/benefits_of_lexi/benefits_2.png';
import benefits_3 from '../assets/Landing_page/benefits_of_lexi/benefits_3.png';
import benefits_4 from '../assets/Landing_page/benefits_of_lexi/benefits_4.png';
import benefits_5 from '../assets/Landing_page/benefits_of_lexi/benefits_5.png';
// benefits of lexilearn end


import './landingpage.css'
import Contact from './Contact';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';



const LandingPage = () => {

    // changes desktop image perspective start 
    const imgRef = useRef(null);

    const handleMouseMove = (e) => {
        const img = imgRef.current;
        const rect = img.getBoundingClientRect();
        const imgWidth = rect.width;
        const imgHeight = rect.height;
        const centerX = rect.left + imgWidth / 2;
        const centerY = rect.top + imgHeight / 2;
        const mouseX = e.clientX - centerX;
        const mouseY = e.clientY - centerY;

        const rotateX = (mouseY / imgHeight) * -50; // Adjust for tilt intensity
        const rotateY = (mouseX / imgWidth) * 50;

        img.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translate(${mouseX * 0.05}px, ${mouseY * 0.05}px)`;
    };

    const handleMouseLeave = () => {
        const img = imgRef.current;
        img.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translate(0px, 0px)';
    };
    // changes desktop image perspective end
    return (
        <div>
            <ToastContainer position='top-right' autoClose={3000} />

            <LandingHeader />

            <div id='home' className='hero_section mt-[50px] '>

                <div className='boy_image '>
                    {/* <div className='boy_over_shadow bg-[#575f86]/50 '>

                            </div> */}
                    <div className='big_screen_view_boy_img_content'>
                        <div className='flex justify-around gap:[0px] 2xl:gap:[200px]  pt-[0px] 2xl:pt-[150px] ' >
                            <div className='flex items-end mb-[40px]' >
                                <div className='px-[80px] 2xl:px-[0px]'>
                                    <h3 className='text-white_color text-[20px] xl:text-[36px] font-thin leading-[40px] xl:leading-[80px]'>A Platform to</h3>
                                    <h2 className='text-white_color text-[50px] xl:text-[70px] font-semibold leading-[40px] xl:leading-[80px]'>Elevate Reading &</h2>
                                    <h2 className='text-white_color text-[50px] xl:text-[70px] font-semibold '>Comprehension</h2>

                                    <Link to="contact-us">
                                        <button id='' className='button_red'>Join Now</button>
                                    </Link>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div className='computer_img'>
                                <img className=''

                                    src={laptop_1}
                                    alt="computer"

                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='mobile_view_hero_boy_content text-main_color'>
                    <div className=' flex flex-wrap justify-around gap:[0px] 2xl:gap:[200px]  pt-[0px] 2xl:pt-[150px] ' >
                        <div className='computer_img'>
                            <img className='' src={laptop_1} alt="computer" />
                        </div>
                        <div className='flex items-end mb-[40px]' >
                            <div className=' 2xl:px-[0px]'>
                                <h3 className=' text-[30px] xl:text-[36px] font-thin leading-[40px] xl:leading-[80px]'>A Platform to</h3>
                                <h2 className=' text-[45px] xl:text-[70px] font-semibold leading-[40px] xl:leading-[80px]'>Elevate Reading &</h2>
                                <h2 className=' text-[45px] xl:text-[70px] font-semibold '>Comprehension</h2>

                                <a href="/contact-us">
                                    <button className='button_red'>Join Now</button>
                                </a>
                            </div>
                            <div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='max-w-[1300px] flex justify-center m-auto px-[10px]'>
                <div>


                    {/* section 2 start  */}

                    <div id='about' className='sec2_container w-full mt-[40px]'>
                        <div className='FJCIC gap40 section_2_container'>

                            <div className='w-auto xl:w-[45%] sec_2_left_girl'>
                                <img src={section2_girl} alt="girl image" />
                            </div>

                            <div className='w-[100%]  lg:w-[55%]  text-main_color'>
                                <div>
                                    <img src={logo2} alt="logo 2" />
                                </div>

                                {/* <div className='sec_2_right_girl'>
                                    <img src={section2_girl} alt="girl image" />
                                </div> */}

                                <div className='w-full text-center lg:text-start mt-[20px] font-semibold lg:w-[90%]'>
                                    <p>
                                        LexiLearn is a research-backed, tech-driven platform to build and elevate English reading and comprehension skills in learners of all ages. It is developed by a group of educators and technicians dedicated to the pursuit of excellence in comprehension and communication.
                                    </p>
                                    <div className='mt-[20px]'>
                                        <Link to="/about-us">
                                            <button className='button_red'>Know More</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    {/* section 2 end */}


                    {/* section 3 start  */}
                    <div id='why-lexilearn' className='sec2_container w-full bg-main_color3 py-[60px] mt-[40px]'>
                        <div className='FJCIC'>
                            <h2 className='UPPERCASE text-center text-main_color font-extrabold text-[25px]  lg:text-[30px] xl:text-[44px] font-sans'>
                                {/* Why reading to comprehend is important */}
                                Why Reading & Comprehension Is Important
                            </h2>
                        </div>



                        <div className='newPaperCutting '>

                            <div className='newspaperText'>
                                <p><span className='text-[34px] font-extrabold '>“53</span>percent of children in low- and middle-income countries cannot read and understand a simple story by the end of primary school. In poor countries, the level is as high as 80 percent…These reading gaps continue to persist in higher grades.”</p>
                            </div>


                        </div>
                        <div className='flex justify-end text-black font-semibold'>
                            <p>– World Bank and the UNESCO Institute for Statistics.</p>
                        </div>


                        <div className='FJCIC mt-[40px]'>
                            <h2 className='text-center text-main_color2 font-normal text-[30px] lg:text-[44px] font-sans mt-[20px]'>LexiLearn is the Solution!</h2>
                        </div>


                        <div className='flex justify-center text-main_color font-semibold text-center'>
                            <div className='w-[90%]'>
                                <p className=''>LexiLearn is designed to address the reading and comprehension gaps among learners from grade 1 to post graduate level. It adopts a scientific approach to identify the gaps through a lexile framework and enables guided improvement through measurable outcomes.</p>
                            </div>
                        </div>

                        <div className='all_card_container'>
                            <div className='card_container '>

                                <div className='card_1'>
                                    <div>

                                        <div className='card  text-[105px] font-extrabold text-[#E9564B]/10 w-[100%] text-center'>
                                            01
                                            <div className='rotate_card card_logo  bg-white  p-[5px]'>
                                                {/* <div className='card_logo'> */}
                                                <img className='' src={card1} alt="globally accepted" />
                                                {/* </div> */}
                                            </div>

                                        </div>
                                    </div>
                                    <div className='flex items-center flex-col text-center'>
                                        <div className='w-[70%] h-[2px] bg-main_color2'></div>
                                        <div className='mt-[20px]'>
                                            <p className='text-[18px] text-main_color font-semibold '>
                                                Mapped with Globally Accepted Lexile levels
                                            </p>
                                        </div>
                                    </div>
                                </div>



                                <div className='card_1'>
                                    <div>

                                        <div className='card text-[105px] font-extrabold text-[#E9564B]/10 w-[100%] text-center'>
                                            02
                                            <div className='rotate_card card_logo bg-white p-[5px]'>
                                                <img className='' src={card2} alt="globally accepted" />
                                            </div>

                                        </div>
                                    </div>
                                    <div className='flex items-center flex-col text-center'>
                                        <div className='w-[70%] h-[2px] bg-main_color2'></div>
                                        <div className='mt-[20px]'>
                                            <p className='text-[18px] text-main_color font-semibold '>
                                                Grade-Appropriate Content for Learners of all ages
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div className='card_1'>
                                    <div>

                                        <div className='card text-[105px] font-extrabold text-[#E9564B]/10 w-[100%] text-center'>
                                            03
                                            <div className='rotate_card card_logo bg-white p-[5px]'>
                                                <img className='' src={card3} alt="globally accepted" />
                                            </div>

                                        </div>
                                    </div>
                                    <div className='flex items-center flex-col text-center'>
                                        <div className='w-[70%] h-[2px] bg-main_color2'></div>
                                        <div className='mt-[20px]'>
                                            <p className='text-[18px] text-main_color font-semibold '>
                                                Rubrics to evaluate reading and comprehension
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div className='card_1'>
                                    <div>

                                        <div className='card text-[105px] font-extrabold text-[#E9564B]/10 w-[100%] text-center'>
                                            04
                                            <div className='rotate_card card_logo bg-white  p-[5px]'>
                                                <img className='' src={card4} alt="globally accepted" />
                                            </div>

                                        </div>
                                    </div>
                                    <div className='flex items-center flex-col text-center'>
                                        <div className='w-[70%] h-[2px] bg-main_color2'></div>
                                        <div className='mt-[20px]'>
                                            <p className='text-[18px] text-main_color font-semibold '>
                                                Progress reports to track growth
                                            </p>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                    {/* section 3 end */}



                    {/* section 4 start Who is LexiLearn for  */}
                    <div id='end-users' className='section_3_container py-[60px] relative mb-[80px] '>
                        <div className='cross_image'>
                            <div className='FJCIC'>
                                <h2 className='text-center text-white_color font-[400] text-[30px] lg:text-[44px] from-neutral-50 mt-[20px]'>Who is LexiLearn for?</h2>
                            </div>

                            <div className='flex justify-center text-white_color font-normal text-[14px] w-full '>
                                <div className='w-[100%] lg:w-[50%] text-center'>
                                    <p className='w-full'>
                                        Progressive educational institutions committed to building strong literacy skills in learners will benefit hugely from LexiLearn.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='absolute w-[90%] lg:w-[80%] flex justify-center flex-wrap  gap-[40px] top-[160%] lg:top-[120%] left-[50%] translate-x-[-50%] translate-y-[-50%]'>


                            <div className="card  w-full lg:w-[40%] ">
                                <div className="backdropFilter ">
                                    <img className='' src={schools} alt="" />
                                </div>
                                <div className='cross_image_school_and_college'>
                                    <div className='flex text-[30px] text-white py-[30px] justify-center gap-[20px]'>
                                        <span><img src={school_icon} alt="" /></span>
                                        <span>Schools</span>
                                    </div>
                                </div>
                            </div>

                            <div className="card w-full lg:w-[40%] ">
                                <div className=" backdropFilter">
                                    <img className='' src={college} alt="" />
                                </div>
                                <div className='cross_image_school_and_college'>
                                    <div className='flex text-[30px] text-white py-[30px] justify-center gap-[20px]'>
                                        <span><img src={college_icon} alt="" /></span>
                                        <span>Colleges</span>
                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                    {/* section 4 end Who is LexiLearn for*/}


                    {/* section 5 start  */}
                    <div id='how-it-works' className='w-full  flex justify-center'>
                        <div className='flex justify-center flex-wrap gap-4 mt-[500px]  xl:mt-[200px]  w-full 2xl:w-[80%]'>
                            <div className='w-[90%] xl:w-[55%] text-start'>
                                <div className='my-[30px]'>
                                    <h2 className=' text-main_color font-[400] text-[44px] from-neutral-50 mt-[20px]'>How It Works?</h2>
                                </div>

                                <div className='text-main_color font-semibold my-[40px] xl:my-[80px]'>
                                    <ol type="1" className='how_it_works_list'>
                                        <li>
                                            The platform subscriber gets access to the LexiLearn tool with a repository of reading material for different lexile levels.
                                        </li>
                                        <li>
                                            Under the supervision of a teacher, a learner reads the text and undergoes assessment for reading speed and comprehension.
                                        </li>
                                        <li>
                                            {/* The AI-supported LexiLearn architecture provides real-time data, automatically tallying a reader’s scores to the globally accepted Lexile framework. */}
                                            The LexiLearn architecture provides real-time data and tallies a reader’s scores to the globally accepted Lexile framework.
                                        </li>
                                        <li>
                                            Based on a reader’s performance, the tool adjusts the difficulty and assigns literacy task with the most appropriate Lexile range, ensuring a truly personalized literacy experience.
                                        </li>
                                        <li>
                                            Step by step, the learner is brought on par with his or her lexile level and is shaped into a fluent reader and eloquent speaker.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            <div className='flex items-end'>
                                <img src={boy_thinking} alt="boy thinking" />
                            </div>
                        </div>
                    </div>
                    {/* section 5 end */}



                    {/* section 6 start  */}
                    <div id='benefits' className='section_3_container pb-[60px] relative mb-[20px]'>
                        <div className='cross_image_benefits'>
                            <div className='FJCIC'>
                                <h2 className=' text-white_color font-[400] text-[30px] xl:text-[44px] from-neutral-50 mt-[20px]'>Benefits of LexiLearn</h2>
                            </div>


                        </div>

                        <div className='absolute flex flex-wrap justify-center z-0 w-full xl:flex-nowrap gap-[40px] top-[205%] xl:top-[80%] left-[50%] translate-x-[-50%] translate-y-[-50%]'>


                            <div className="benefits_card ">
                                <div>
                                    <div className="benefits_img_container">
                                        <img src={benefits_1} alt="" />
                                    </div>
                                    <div className='marginTp40'>
                                        <p className='text-main_color font-semibold text-center text-[18px]'>Substantially enhances English reading speed and comprehension</p>
                                    </div>
                                </div>

                            </div>



                            <div className="benefits_card ">
                                <div>
                                    <div className="benefits_img_container">
                                        <img src={benefits_2} alt="" />
                                    </div>
                                    <div className='marginTp40'>
                                        <p className=' text-[18px] text-main_color font-semibold text-center'>
                                            Spurs cognitive development in young learners
                                        </p>
                                    </div>
                                </div>

                            </div>




                            <div className="benefits_card ">
                                <div>
                                    <div className="benefits_img_container">
                                        <img src={benefits_3} alt="" />
                                    </div>
                                    <div className='marginTp40'>
                                        <p className='text-[18px] text-main_color font-semibold text-center'>
                                            Develops learners into confident communicators
                                        </p>
                                    </div>
                                </div>

                            </div>




                            <div className="benefits_card ">
                                <div>
                                    <div className="benefits_img_container">
                                        <img src={benefits_4} alt="" />
                                    </div>
                                    <div className='marginTp40'>
                                        <p className=' text-[18px] text-main_color font-semibold text-center'>
                                            Makes readers independent and lifelong learners
                                        </p>
                                    </div>
                                </div>

                            </div>




                            <div className="benefits_card ">
                                <div>
                                    <div className="benefits_img_container">
                                        <img src={benefits_5} alt="" />
                                    </div>
                                    <div className='marginTp40'>
                                        <p className=' text-[18px] text-main_color font-semibold text-center'>
                                            Increases chances of academic and professional success
                                        </p>
                                    </div>
                                </div>

                            </div>




                        </div>

                    </div>
                    {/* section 6 end */}



                    {/* section 7 start  */}
                    <div id='measures' className='section_3_container mb-[80px] mt-[800px] xl:mt-[120px] '>
                        <div className='cross_image'>
                            <div className='FJCIC'>
                                <h2 className=' text-white_color font-[400] text-center text-[30px] xl:text-[44px] from-neutral-50 mt-[20px]'>Lexile Reader and Text Measures</h2>
                            </div>

                            <div className='flex justify-center text-white_color font-normal text-[14px] w-full '>
                                <div className='w-[90%] xl:w-[50%] text-center'>
                                    <p className='w-full '>
                                        The end users of LexiLearn will be educators who use the resources of the platform to build strong reading and comprehension abilities in learners.
                                    </p>
                                </div>
                            </div>
                            <div className='flex justify-center mt-[20px]'>
                                <a href="/measure">
                                    <button className='button_red'>KNOW MORE</button>
                                </a>
                            </div>
                        </div>


                    </div>
                    {/* section 7 end */}
                </div>
            </div>
            <Contact />
            <Footer />








        </div>



    )
}

export default LandingPage